export default {"src":"/_next/static/media/30-icon.d17babd9.svg","height":41,"width":46,"blurWidth":0,"blurHeight":0};